import {
  MILITARY_STATUS_VALUES,
  TRAINING_LEVEL,
  validEducationLevels
} from '../../../utils/constants';
/**
 * Set up rules for rendering badges, here we can also set up custom methods
 * to handle other methods.
 * */

export class BadgeController {
  // returns array of badges
  get badges() {
    return [
      {
        name: 'VeteranBadge',
        weight: 90,
        shouldRender: ({ militaryStatus }) => {
          if (militaryStatus !== MILITARY_STATUS_VALUES.VETERAN) {
            return false;
          }
          return true;
        },
        analyticsName: 'veteran'
      },
      {
        name: 'BootcampBadge',
        weight: 100,
        shouldRender: function renderBootcampBadge({ accreditations }) {
          return !!accreditations?.includes(TRAINING_LEVEL.BOOTCAMP);

        },
        analyticsName: 'skills program'
      },
      {
        name: 'EducationBadge',
        weight: 80,
        shouldRender: function renderEducationBadge({ education }) {
          // valid education levels for degree

          // check if value is valid
          return !!validEducationLevels?.includes(education);
        },
        analyticsName: 'education'
      },
      // no backend for this yet
      {
        name: 'AccreditedTrainingBadge',
        weight: 70,
        shouldRender: function renderAccreditedTrainingBadge({ accreditations }) {
          return !!accreditations?.includes(TRAINING_LEVEL.ACC_TRAIN_PGM);

        },
        analyticsName: 'accredited training'
      },
      {
        name: 'BehrTrainingBadge',
        weight: 60,
        shouldRender: function renderBehrTrainingBadge({ accreditations }) {
          return !!accreditations?.includes(TRAINING_LEVEL.BEHR_TRAINING_PGM);
        },
        analyticsName: 'Behr Training'
      }

    ];
  }

  // returns the badges sorted by weight
  get badgesByWeight() {
    return this.badges.sort(function sortBadge(a, b) {
      if (a.weight > b.weight) {
        return -1;
      }
      if (a.weight < b.weight) {
        return 1;
      }
      return 0;
    });
  }

  // check profile for badges
  profileHasBadges(profileData) {
    let profileHasBadge = false;
    this.badges.some((badge) => {
      if (badge.shouldRender(profileData)) {
        profileHasBadge = true;
        return true;
      }
    });
    return profileHasBadge;
  }
}
